import HeartIcon from './component.jsx'
export default HeartIcon
